// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__B7xXL","inner":"PageHeader_inner__UOaH8","tabs":"PageHeader_tabs__eRozF","hasSearch":"PageHeader_hasSearch__jPykR","search":"PageHeader_search__B8OFS"};